'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsModules = exports.CmsModuleShape = exports.CmsModulesUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _decorator = require('helpers/decorator');

var _verify = require('helpers/verify');

var _cms = require('redux/saga/selectors/cms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    path: (0, _cms.selectCmsPath)(state)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  // We need to map dispatch for compatibility reasons
  // in the short term. It will be removed in the near future
  // as we make modules connected.
  dispatch: function dispatch(obj) {
    return obj;
  }
};

var CmsModulesUnwrapped = exports.CmsModulesUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(CmsModulesUnwrapped, _React$Component);

  function CmsModulesUnwrapped() {
    (0, _classCallCheck3.default)(this, CmsModulesUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (CmsModulesUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(CmsModulesUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(CmsModulesUnwrapped, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          modules = _props.modules,
          path = _props.path;


      if ((0, _verify.isEmpty)(modules)) {
        return null;
      }

      return modules.map(function (_ref, index) {
        var Component = _ref.Component,
            cmsModuleId = _ref.cmsModuleId,
            props = _ref.props;
        return _react2.default.createElement(
          'div',
          {
            'data-cms-module-id': cmsModuleId,
            key: Component.displayName + '_' + index // eslint-disable-line react/no-array-index-key
          },
          _react2.default.createElement(Component, (0, _extends3.default)({
            cmsModuleId: cmsModuleId,
            path: path
          }, props, Component.handlerMapper ? Component.handlerMapper(dispatch) : {}))
        );
      });
    }
  }]);
  return CmsModulesUnwrapped;
}(_react2.default.Component);

var CmsModuleShape = exports.CmsModuleShape = _propTypes2.default.shape({
  cmsModuleId: _propTypes2.default.string.isRequired,
  Component: _propTypes2.default.func.isRequired,
  props: _propTypes2.default.object.isRequired
});

CmsModulesUnwrapped.propTypes = {
  dispatch: _propTypes2.default.func,
  modules: _propTypes2.default.arrayOf(CmsModuleShape),
  path: _propTypes2.default.string
};

var CmsModules = exports.CmsModules = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(CmsModulesUnwrapped);